import React from "react";
import { observer } from "mobx-react";
import { AuthorPublisherCreateStore } from "../../store";
import { AuthorPublisherCreateForm } from "./AuthorPublisherCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AuthorPublisherCreateProps = {
  authorPublisherCreateStore: AuthorPublisherCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AuthorPublisherCreate: React.FC<AuthorPublisherCreateProps> =
  observer(
    ({ authorPublisherCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={authorPublisherCreateStore.isSaving} />
          <AuthorPublisherCreateForm
            authorPublisherCreateStore={authorPublisherCreateStore}
            publisherError={
              authorPublisherCreateStore.errors.publisher?.message
            }
            onPublisherChange={(value) => {
              authorPublisherCreateStore.setPublisherValue(value);
            }}
            publisherSelectedValue={
              authorPublisherCreateStore.entityValues.showPublisher
            }
            onPublisherSelected={(value) => {
              authorPublisherCreateStore.setSelectedPublisher(value);
            }}
            publisherOptions={authorPublisherCreateStore.getPublisherOptions()}
            percentageError={
              authorPublisherCreateStore.errors.percentage?.message
            }
            onPercentageChange={(value: number) => {
              authorPublisherCreateStore.setPercentageValue(value);
            }}
            percentage={authorPublisherCreateStore.entityValues.percentage}
            durationInYearsError={
              authorPublisherCreateStore.errors.durationInYears?.message
            }
            onDurationInYearsChange={(value: number | undefined) => {
              authorPublisherCreateStore.setDurationInYearsValue(value);
            }}
            durationInYears={
              authorPublisherCreateStore.entityValues.durationInYears
            }
            autoRenewalYearsError={
              authorPublisherCreateStore.errors.autoRenewalYears?.message
            }
            onAutoRenewalYearsChange={(value: number | undefined) => {
              authorPublisherCreateStore.setAutoRenewalYearsValue(value);
            }}
            autoRenewalYears={
              authorPublisherCreateStore.entityValues.autoRenewalYears
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={authorPublisherCreateStore.isProcessing}
            onSave={() => authorPublisherCreateStore.saveNewAuthorPublisher()}
            onCancel={() =>
              authorPublisherCreateStore.cancelNewAuthorPublisher()
            }
          />
          <ErrorDialog
            open={authorPublisherCreateStore.errorDialogOpened}
            title={authorPublisherCreateStore.errorTitle}
            description={authorPublisherCreateStore.errorDescription}
            onClose={() => authorPublisherCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
